// store/getters.js
export default {
  isLoggedIn: state => state.isLoggedIn,
  userEmail: state => state.userEmail,
  userZipCode: state => state.userZipCode, // Add getter for zip code
};
